module.exports = __webpack_public_path__ + "static/media/viarspaceMetalSignMockup_04.6a4e4718.png";